<template>
  <div class="select-mcc">
    <van-popup
      v-model="showPopup"
      position="bottom"
      :close-on-popstate="true"
      @click-overlay="onCancel"
    >
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { storeAssistEntryGetBizTypeList } from '@/api/assist-operation'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    queryUpstream: {
      type: [String, Number],
      default: ''
    },
    id: {
      type: [String, Number],
      default: ''
    },
    // 商户类型0企业 1个体 2小微
    merMode: {
      type: [String, Number],
      default: ''
    },
    pageType: {
      type: [String],
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      provinceList: [],
      cityList: [],
      form: {
        bankCardProvince: ''
      },
      columns: [
        {
          text: '请选择',
          value: '',
          disabled: true
        }
      ],
      showPopup: this.show
    }
  },
  watch: {
    show(newVal) {
      this.showPopup = newVal
      if (newVal) {
        this.columns = [
          {
            text: '请选择',
            value: '',
            disabled: true
          }
        ]
        this.getBusinessAssistMcc()
      }
    }
  },
  methods: {
    // 选择行业类目
    getBusinessAssistMcc() {
      let params = {
        assistEntryId: this.id,
        merMode: this.merMode
      }
      console.log('getBusinessAssistMcc-params', params)
      storeAssistEntryGetBizTypeList(params).then(res => {
        res.forEach(item => {
          this.columns.push({
            text: item.mccIndustryType,
            code: item.mcc
          })
        })
      })
    },
    onCancel() {
      this.$emit('close')
    },
    onConfirm(values) {
      console.log('values', values)
      this.$emit('close')
      this.$emit('confirm', values)
    }
  }
}
</script>

<style scoped lang="less">
.select-region {
  .content {
    height: 100%;
    box-sizing: border-box;
    .header {
      height: 108px;
      font-size: 34px;
      font-weight: 500;
      color: #1a1a1a;
      display: flex;
      align-items: center;
      padding: 30px 36px;
      box-sizing: border-box;
      .close {
        width: 44px;
        height: 44px;
        margin-left: auto;
      }
    }
    .select-result {
      height: 82px;
      padding: 20px 36px;
      display: flex;
      align-items: center;
      font-size: 32px;
      color: #000;
      box-sizing: border-box;
      border-bottom: 1px solid #f0f0f0;
      .result {
        display: flex;
        align-items: center;
        margin-right: 54px;
        color: #000;
        .dot {
          width: 10px;
          height: 10px;
          background: #ff3934;
          border-radius: 10px;
          margin-right: 12px;
        }
      }
      text {
        color: #ff3934;
      }
    }
    .list {
      padding: 30px 36px;
      height: calc(100% - 190px);
      box-sizing: border-box;
      .item {
        font-size: 30px;
        color: #333333;
        height: 96px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;
        &:active {
          background-color: #fafafa;
        }
      }
    }
  }
}
</style>
